import React from 'react';
import { Car } from 'lucide-react';


export const StageTravel = function({ planData, updateData }) {

  return (

          <div className="space-y-6">
            <div>
              <label className="block text-sm font-medium mb-2">Domestic Travel Notification</label>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                {[
                  { id: '48h', label: '48 Hours' },
                  { id: '72h', label: '72 Hours' },
                  { id: '7days', label: '7 Days' },
                  { id: '14days', label: '14 Days' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('travelNotice', opt.id); }}
                      className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                        (planData.travelNotice === opt.id ? 'border-[#5A4E9E] bg-[#5A4E9E]/10' : 'border-white/10 hover:border-white/20')}>
                      {opt.label}
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Travel Itinerary Sharing</label>
              <div className="grid grid-cols-2 gap-2">
                {[
                  { id: 'required', label: 'Required (addresses, flights, contact info)' },
                  { id: 'destination-only', label: 'Destination & Contact Only' },
                  { id: 'optional', label: 'Optional / Courtesy' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('travelItinerary', opt.id); }}
                      className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                        (planData.travelItinerary === opt.id ? 'border-[#5A4E9E] bg-[#5A4E9E]/10' : 'border-white/10 hover:border-white/20')}>
                      {opt.label}
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Neighboring States Travel Exemption</label>
              <p className="text-xs text-white/40 mb-3">Should travel to immediate neighboring states be exempt from notice and itinerary requirements?</p>
              <div className="grid grid-cols-2 gap-2">
                {[
                  { id: 'exempt', label: 'Yes — No Notice or Itinerary Required', desc: 'Travel to bordering states does not require advance notice or itinerary sharing' },
                  { id: 'not-exempt', label: 'No — Standard Rules Apply', desc: 'All domestic travel rules apply regardless of destination state' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('neighboringStatesExempt', opt.id); }}
                      className={'p-3 rounded-lg border text-left transition-all ' +
                        (planData.neighboringStatesExempt === opt.id ? 'border-[#5A4E9E] bg-[#5A4E9E]/10' : 'border-white/10 hover:border-white/20')}
                      data-testid={'neighboring-states-' + opt.id}>
                      <p className="font-medium text-sm">{opt.label}</p>
                      <p className="text-xs text-white/50 mt-0.5">{opt.desc}</p>
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">International Travel</label>
              <div className="space-y-2">
                {[
                  { id: 'both-consent', name: 'Both Parents Must Consent', desc: 'Written consent required from both parents for international travel' },
                  { id: 'written-consent', name: 'Written Consent + Itinerary', desc: 'Consent required along with full travel itinerary' },
                  { id: 'notify-only', name: 'Notify Only', desc: 'Notification only, no consent required' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('internationalTravel', opt.id); }}
                      className={planData.internationalTravel === opt.id
                        ? 'w-full p-3 rounded-lg border text-left border-[#5A4E9E] bg-[#5A4E9E]/10'
                        : 'w-full p-3 rounded-lg border text-left border-white/10 hover:border-white/20'}>
                      <p className="font-medium text-sm">{opt.name}</p>
                      <p className="text-xs text-white/50">{opt.desc}</p>
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Passport Holding</label>
              <div className="grid grid-cols-2 gap-2">
                {[
                  { id: 'joint', label: 'Joint Possession' },
                  { id: 'plaintiff', label: 'With Plaintiff' },
                  { id: 'defendant', label: 'With Defendant' },
                  { id: 'attorney', label: 'With Attorney / Third Party' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('passportHolding', opt.id); }}
                      className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                        (planData.passportHolding === opt.id ? 'border-[#5A4E9E] bg-[#5A4E9E]/10' : 'border-white/10 hover:border-white/20')}>
                      {opt.label}
                    </button>
                  );
                })}
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium mb-2">Relocation Notification Period</label>
                <select value={planData.relocationNotice} onChange={function(e) { updateData('relocationNotice', e.target.value); }}
                  className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2">
                  <option value="30days">30 Days</option>
                  <option value="60days">60 Days</option>
                  <option value="90days">90 Days</option>
                  <option value="120days">120 Days</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">Relocation Restriction</label>
                <select value={planData.relocationDistance} onChange={function(e) { updateData('relocationDistance', e.target.value); }}
                  className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2">
                  <option value="any">No Restriction</option>
                  <option value="same-district">Same School District</option>
                  <option value="10mi">Within 10 Miles</option>
                  <option value="20mi">Within 20 Miles</option>
                  <option value="30mi">Within 30 Miles</option>
                  <option value="40mi">Within 40 Miles</option>
                  <option value="50mi">Within 50 Miles</option>
                  <option value="100mi">Within 100 Miles</option>
                  <option value="same-county">Same County</option>
                  <option value="same-state">Same State</option>
                  <option value="out-of-state">Court Approval for Out-of-State</option>
                </select>
              </div>
            </div>

            {/* Custody Exchange Travel Costs */}
            <div className="border-t border-white/[0.06] pt-6">
              <div className="flex items-center gap-2 mb-4">
                <Car className="w-5 h-5 text-[#5A4E9E]" />
                <label className="block text-sm font-bold">Custody Exchange Travel Costs</label>
              </div>
              <p className="text-xs text-white/40 mb-4">Who is responsible for the travel costs (gas, mileage, tolls, airfare) associated with custody exchanges and transportation?</p>
              <div className="space-y-2">
                {[
                  { id: 'equal-split', label: 'Split Equally (50/50)', desc: 'Both parties share all transportation costs equally' },
                  { id: 'sending-parent', label: 'Sending Parent Pays', desc: 'The parent dropping off the child is responsible for their own travel costs' },
                  { id: 'receiving-parent', label: 'Receiving Parent Pays', desc: 'The parent picking up the child is responsible for their own travel costs' },
                  { id: 'plaintiff-pays', label: 'Plaintiff Pays All', desc: 'Plaintiff bears all transportation costs for custody exchanges' },
                  { id: 'defendant-pays', label: 'Defendant Pays All', desc: 'Defendant bears all transportation costs for custody exchanges' },
                  { id: 'proportional-income', label: 'Proportional to Income', desc: 'Transportation costs divided proportionally based on each party\'s gross income' },
                  { id: 'own-costs', label: 'Each Pays Their Own', desc: 'Each party is responsible for their own transportation costs without reimbursement' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('exchangeTravelCost', opt.id); }}
                      data-testid={'travel-cost-' + opt.id}
                      className={'w-full p-3 rounded-lg border text-left transition-all ' +
                        (planData.exchangeTravelCost === opt.id ? 'border-[#5A4E9E] bg-[#5A4E9E]/10' : 'border-white/10 hover:border-white/20')}>
                      <p className="text-sm font-medium">{opt.label}</p>
                      <p className="text-xs text-white/40">{opt.desc}</p>
                    </button>
                  );
                })}
              </div>

              {/* Mileage reimbursement rate for split/proportional */}
              {planData.exchangeTravelCost && planData.exchangeTravelCost !== 'own-costs' && planData.exchangeTravelCost !== 'plaintiff-pays' && planData.exchangeTravelCost !== 'defendant-pays' && (
                <div className="mt-4 p-4 bg-[#5A4E9E]/5 border border-[#5A4E9E]/20 rounded-xl" data-testid="mileage-rate-section">
                  <label className="block text-sm font-medium mb-2">Mileage Reimbursement Rate</label>
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                    {[
                      { id: 'irs-rate', label: 'IRS Standard Rate', desc: 'Current federal mileage rate' },
                      { id: 'flat-rate', label: 'Flat Rate ($0.50/mile)', desc: 'Fixed per-mile reimbursement' },
                      { id: 'actual-cost', label: 'Actual Costs', desc: 'Gas, tolls, parking receipts' },
                    ].map(function(opt) {
                      return (
                        <button key={opt.id} onClick={function() { updateData('exchangeTravelMileageRate', opt.id); }}
                          data-testid={'mileage-rate-' + opt.id}
                          className={'p-3 rounded-lg border text-left transition-all ' +
                            (planData.exchangeTravelMileageRate === opt.id ? 'border-[#5A4E9E] bg-[#5A4E9E]/10' : 'border-white/10 hover:border-white/20')}>
                          <p className="text-xs font-medium">{opt.label}</p>
                          <p className="text-xs text-white/40">{opt.desc}</p>
                        </button>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        
  );
};
